import Globals from "./../../globals";

export const utilsMixin = {
    methods: {
        getCleanUrl(urlToClean) {
            if (!urlToClean) return "";
            // let urlTmp = mod.src
            let url = "";
            if (urlToClean.startsWith("http")) {
                let urlReplace = urlToClean.replace("http://", "").replace("https://", "");
                url = Globals.prefixUrl + urlReplace;
            } else {
                url = Globals.getBaseUrl() + urlToClean;
            }
            // console.log(urlToClean, url, '======================= url')
            return url;
        },
        UUID() {
            return Globals.UUID();
        },
        assign(obj) {
            return this._.cloneDeep(obj);
        },
        sleep(time) {
            return new Promise(resolve => setTimeout(resolve, time));
        },
        upBuilderField(field, value) {
            this.$store.commit("plano/status/updateBuilder", { field, value });
        },
        elementFromPoint(query, x, y) {
            let elts = document.querySelectorAll(query);
            let elt;
            // console.log(elts, '==============')
            for (let i = 0, l = elts.length; i < l; i++) {
                elt = elts[i];
                let bb = elt.getBoundingClientRect();
                // console.log(bb, elt)
                if (x >= bb.x && y >= bb.y && x <= bb.x + bb.width && y <= bb.y + bb.height) {
                    return elt;
                }
            }

            return null;
        },
        elementsFromPoint(query, x, y) {
            let elts = document.querySelectorAll(query);
            let elt;
            let elements = [];
            // console.log(elts, '==============')
            for (let i = 0, l = elts.length; i < l; i++) {
                elt = elts[i];
                let bb = elt.getBoundingClientRect();
                // console.log(bb, elt)
                if (x >= bb.x && y >= bb.y && x <= bb.x + bb.width && y <= bb.y + bb.height) {
                    elements.push(elt);
                }
            }

            return elements;
        }
    },

    getImgPathSvg(imgPath) {
        let ret = this._.find(imgPath.figures_advanced, o => o.id_type_file === 6);

        if (typeof ret !== "undefined") {
            return ret.big;
        } else {
            return "/static/assets/svg/generic_module-01.svg";
        }
    },

    getPlanoImgReal(imgPath) {
        let ret = this._.find(imgPath.figures_advanced, o => o.id_type_file === 5);

        if (typeof ret !== "undefined") {
            return ret.big;
        } else {
            return null;
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/plano/mixins/utils.js